import { Flex, Tooltip } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';

import { Approval } from '@/app/org-cfv/src/typings/ActivityDataDetailsTypings';
import { EmissionsType } from '@/app/org-cfv/src/typings/CreateActivityDataTypings';
import { HiOutlineCollectionIcon } from '@/components/common/Icons/HiOutlineCollectionIcon';
import { NextTFunction } from '@/i18n/client';
import { toThousandthString } from '@/utils/numbers';

// This file contains the columns for cat4.3

export const getWasteTransportationWeightHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview
    ? 'metadata.wasteTransportationWeight'
    : 'activityData.metadata.wasteTransportationWeight';
  return {
    header: t('org-cfv-data-entry.wasteTransportationAmount'),
    accessorKey,
    cell: ({ row: { original }, getValue }) =>
      original.isBatch ? (
        <Flex alignItems='center' gap={2} data-testid={`bulk_input`}>
          {t('common.seeDetails')}
          <Tooltip hasArrow label={t('bulk-input.bulkInput')}>
            <HiOutlineCollectionIcon color='gray.300' w='1rem' h='1rem' />
          </Tooltip>
        </Flex>
      ) : (
        toThousandthString(getValue() as number)
      ),
  };
};

export const getWasteTransportationUnitHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview
    ? 'metadata.wasteTransportationUnit'
    : 'activityData.metadata.wasteTransportationUnit';
  return {
    header: t('org-cfv-data-entry.wasteTransportationUnit'),
    accessorKey,
    cell: ({ row: { original }, getValue }) =>
      original.isBatch ? (
        <Flex alignItems='center' gap={2} data-testid={`bulk_input`}>
          {t('common.seeDetails')}
          <Tooltip hasArrow label={t('bulk-input.bulkInput')}>
            <HiOutlineCollectionIcon color='gray.300' w='1rem' h='1rem' />
          </Tooltip>
        </Flex>
      ) : (
        t(`unit.${getValue()}`)
      ),
  };
};

export const getWasteTreatmentAmountHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.usageAmount' : 'activityData.metadata.usageAmount';
  return {
    header: t('org-cfv-data-entry.wasteDisposalAmount'),
    accessorKey,
    cell: ({ row: { original }, getValue }) =>
      original.isBatch ? (
        <Flex alignItems='center' gap={2} data-testid={`bulk_input`}>
          {t('common.seeDetails')}
          <Tooltip hasArrow label={t('bulk-input.bulkInput')}>
            <HiOutlineCollectionIcon color='gray.300' w='1rem' h='1rem' />
          </Tooltip>
        </Flex>
      ) : (
        toThousandthString(getValue() as number)
      ),
  };
};

export const getWasteTreatmentUnitHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.unit' : 'activityData.metadata.unit';
  return {
    header: t('org-cfv-data-entry.wasteDisposalUnit'),
    accessorKey,
    cell: ({ row: { original }, getValue }) =>
      original.isBatch ? (
        <Flex alignItems='center' gap={2} data-testid={`bulk_input`}>
          {t('common.seeDetails')}
          <Tooltip hasArrow label={t('bulk-input.bulkInput')}>
            <HiOutlineCollectionIcon color='gray.300' w='1rem' h='1rem' />
          </Tooltip>
        </Flex>
      ) : (
        t(`unit.${getValue()}`)
      ),
  };
};
